

export async function forEachAsync(arr:any[],callback) {
    for (let index = 0; index < arr.length; index++) {
        await callback(arr[index], index, arr);
    }
}

export function parseJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
        return null;
    }
}